

import Icon from "../components/icon";
import Breadcrumbs from "../components/breadcrumbs";


const Header = (props) => {
    const {title, icon, buttons} = props

    return (
        <div className="Header">
            <div className="row">
                <div className="col-sm-6">
                    <ul className="dynamic-title list-inline list-unstyled">
                        <li className="list-inline-item">
                            <div className="header-icon">
                                <Icon name={icon}/>
                            </div>
                        </li>
                        <li className="list-inline-item">
                            <div>
                                <Breadcrumbs />
                                <h5>{title}</h5>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="col-sm-6 text-end d-flex align-items-center justify-content-end">
                    {buttons && <ul className="list-inline list-unstyled">{
                        buttons.map((button, index) => {
                            return <li key={index} className="list-inline-item">
                                {button}
                            </li>
                        })
                    }</ul>
                    }
                </div>
            </div>

        </div>
    )
}

export default Header;